export { default } from './BGMTab';
